import { getRequest } from '../services/requestHandler';
import { OrderAccountForDropdown } from '../models';

export const getOrderAccountsForDropdown = async () => {
  const url = `orderLookup/getOrderAccountsForDropdown?activeOnly=true`;
  const response = await getRequest<OrderAccountForDropdown>('getOrderAccountsForDropdown', url);
  return response;
};
